import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '../../contexts/AppContext';
import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import TimeLine from './TimeLine';

const queryClient = new QueryClient();

const BrandCampaign = ({ env, isWebview, isSubscriber }) => {
  return (
    <>
      <AppContextProvider env={env} isWebview={isWebview}>
        <QueryClientProvider client={queryClient}>
          <HeaderSection isSubscriber={isSubscriber} />
          <TimeLine />
          <FooterSection isSubscriber={isSubscriber} />
        </QueryClientProvider>
      </AppContextProvider>
    </>
  );
};

export default BrandCampaign;
